/**
 * Layout métrico de la Sede de Referencia Envigado (anteproyecto).
 * Origen del lote: centro del terreno. Unidades en metros. Y=0 a nivel de piso.
 *
 * Distribución del lote (120 × 90 m):
 *  - Edificio institucional 40 × 22 m, dos plantas, centrado en (0, -15).
 *  - Calle de acceso (vía pública genérica) en el borde sur, z = +40.
 *  - Andén peatonal segregado x ∈ [-22, -18], de la calle al acceso.
 *  - Bahía accesible señalizada junto al acceso peatonal.
 *  - Zona preoperacional techada al oriente del edificio.
 *  - Pista de motocicleta 30 × 15 m al occidente.
 *  - Pista de automóvil 60 × 25 m al suroriente, separada por cerramiento.
 */

export const LOT = { width: 120, depth: 90 } as const;

export const BUILDING = {
  width: 40,
  depth: 22,
  floorHeight: 3.2,
  floors: 2,
  wallThickness: 0.2,
  center: [0, 0, -15] as readonly [number, number, number],
} as const;

/** Coordenadas locales del edificio: origen en el centro de la huella. */
export const ROOMS = {
  reception: { x: -20, z: 5, w: 10, d: 6 },
  waiting: { x: -10, z: 5, w: 10, d: 6 },
  sanitarios: { x: 0, z: 8, w: 4, d: 3 },
  cubicles: { x: 4, z: 5, w: 9, d: 6 },
  corridor: { x: -20, z: 3, w: 33, d: 2 },
  theory: { x: -20, z: -11, w: 24, d: 14 },
  supervisor: { x: -20, z: -11, w: 24, d: 2 },
  comms: { x: 4, z: -11, w: 9, d: 6 },
  control: { x: 4, z: -5, w: 9, d: 8 },
} as const;

/** Vía pública FUERA del lote (carril cercano a z≈46-47); cerramiento sur en z = 44 y andén público entre ambos. */
export const STREET = { z: 49.5, width: 7 } as const;
export const FENCE_Z = 44;
/** Andén público entre el cerramiento (44) y la vía (46). */
export const PUBLIC_WALK = { z: 45, width: 2 } as const;
export const SIDEWALK = { x: -20, width: 4, z0: -4, z1: FENCE_Z } as const;

export const ACCESSIBLE_BAY = { x: 12, z: 2, w: 3.6, d: 5 } as const;

export const PREOP = { x: 28, z: -15, w: 12, d: 10, roofHeight: 3.6 } as const;

export const MOTO_TRACK = { x: -40, z: -10, w: 30, d: 15 } as const;
export const CAR_TRACK = { x: 15, z: 22, w: 60, d: 25 } as const;

/**
 * Zona de entrega del vehículo junto al punto de inicio de la primera
 * maniobra [NORMATIVO Anexo 60, num. 2.3.1 Nota 8]: extremo occidental
 * de la pista de autos, al lado de la línea de salida.
 */
export const DELIVERY_ZONE = { x: CAR_TRACK.x - CAR_TRACK.w / 2 + 4, z: CAR_TRACK.z - 8, w: 6, d: 6 } as const;

/** Punto de encuentro al final de la ruta de egreso norte [NORMATIVO Dec. 1072/2015]. */
export const MEETING_POINT = { x: -9, z: -38, radius: 3 } as const;

/** Franja de seguridad de 1 m entre pistas y circulaciones [NORMATIVO Anexo 60, 2.3.1 Nota 6]. */
export const SAFETY_STRIP = 1;

export const BRAND_GREEN = "#006B3F";
